import { render } from "./warehouse-items.vue?vue&type=template&id=8c1179de&scoped=true"
import script from "./warehouse-items.vue?vue&type=script&lang=js"
export * from "./warehouse-items.vue?vue&type=script&lang=js"

import "./warehouse-items.vue?vue&type=style&index=0&id=8c1179de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1179de"]])

export default __exports__